<template>
  <transition name="loader-fade">
    <div v-if="visible" class="loader-overlay">
      <img src="/favicons/obiado-logo-128x128.png" alt="Logo" class="loader-logo" />
      <div class="loader-text">{{ $t("Processing...") }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loader",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.loader-overlay {
  position: fixed;
  top: 32px;
  right: 32px;
  left: auto;
  bottom: auto;
  width: auto;
  height: auto;
  min-width: 120px;
  min-height: 80px;
  background: transparent;
  border-radius: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 18px 28px 18px 28px;

  .loader-logo {
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .loader-text {
      margin-top: 0;
      font-size: 1em;
      color: #333;
    }

    .loader-fade-enter-active,
    .loader-fade-leave-active {
      transition: opacity 0.3s;
    }

    .loader-fade-enter-from,
    .loader-fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
